import React, { FC } from "react";
import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { FaceData, FaceQualityScores } from "../types/PersonType";
import { get } from "http";
import { PersonModel } from "../models/PersonModel";
import clsx from "clsx";

interface Props {
    faceData: FaceData
    show: boolean
    onHide: () => void
}
const FaceQuality: FC<Props> = ({ faceData, show, onHide }) => {
    const { getFaceQualityFinalScore, getFaceQualityScores } = PersonModel();
    const scores = getFaceQualityScores(faceData);
    const finalScore = getFaceQualityFinalScore(scores);
    
    const getFinalLabel = (score: number) => {
        if (score >= 80) {
            return "Excelente";
        } else if (score >= 70) {
            return "Bom";
        } else if (score >= 60) {
            return "Regular";
        } else if (score >= 50) {
            return "Ruim";
        } else {
            return "Péssimo";
        }
    };


    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="example-modal-sizes-title-sm"
            className={clsx("face-quality-modal", {
                "modal-default": finalScore >= 80,
                "modal-error": finalScore < 80,
            })}
            centered
        >
            <Modal.Header closeButton closeVariant="white">
                <Modal.Title id="example-modal-sizes-title-sm">
                    Qualidade da foto
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ul>
                <li><i className={clsx("bi", {
                        "bi-check-circle-fill text-success": scores.pose >= 80,
                        "bi-exclamation-circle-fill text-warning": scores.pose < 80 && scores.pose >= 50,
                        "bi-x-circle-fill text-danger": scores.pose < 50,
                    })} /> Pose do rosto ({getFinalLabel(scores.pose)}).</li>
                <li><i className={clsx("bi", {
                        "bi-check-circle-fill text-success": scores.expression >= 80,
                        "bi-exclamation-circle-fill text-warning": scores.expression < 80 && scores.expression >= 50,
                        "bi-x-circle-fill text-danger": scores.expression < 50,
                    })} /> Expressão facial ({getFinalLabel(scores.expression)}).</li>
                <li><i className={clsx("bi", {
                        "bi-check-circle-fill text-success": scores.quality >= 80,
                        "bi-exclamation-circle-fill text-warning": scores.quality < 80 && scores.quality >= 50,
                        "bi-x-circle-fill text-danger": scores.quality < 50,
                    })} /> Qualidade da imagem ({getFinalLabel(scores.quality)}).</li>
                <li><i className={clsx("bi", {
                        "bi-check-circle-fill text-success": scores.obstructions >= 80,
                        "bi-exclamation-circle-fill text-warning": scores.obstructions < 80 && scores.obstructions >= 50,
                        "bi-x-circle-fill text-danger": scores.obstructions < 50,
                    })} /> Obstruções do rosto ({getFinalLabel(scores.obstructions)}).</li>                    
                <li><i className={clsx("bi", {
                        "bi-check-circle-fill text-success": finalScore >= 80,
                        "bi-exclamation-circle-fill text-warning": finalScore < 80 && finalScore >= 50,
                        "bi-x-circle-fill text-danger": finalScore < 50,
                    })} /> <b>Pontuação final ({getFinalLabel(finalScore)}).</b></li>
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-light" onClick={onHide} className="btn-custom btn-custom-light">
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default FaceQuality;